import { AppBar, Box, Toolbar } from '@mui/material';
import { styled } from '@mui/system';
import theme from '../../theme';
import ProjectDetailsBar from './components/ProjectDetailsBar';
import { ReactComponent as DiscussionIcon } from './../../assets/icons/discussion.svg';
import { ReactComponent as DiscussionNotificationIcon } from './../../assets/icons/discussion-notification.svg';
import { ReactComponent as FeedbackSvg } from './../../assets/icons/feedback.svg';
import { ReactComponent as BugSvg } from './../../assets/icons/bug.svg';

interface ProfileIconBoxProps {
    isOpen?: boolean;
}

export const StyledAppBar = styled(AppBar)`
    background-color: ${theme.color.blackRock} !important;
    grid-area: logo;
`;

export const StyledToolbar = styled(Toolbar)`
    display: flex;
    justify-content: space-between;
    position: relative;
`;

export const LogoContainer = styled(Box)`
    display: flex;
    align-items: center;
    flex: 1;
`;

export const ProjectsMenu = styled(ProjectDetailsBar)`
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
`;

export const RightControls = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
    flex: 1;
`;

export const ProfileIconBox = styled(Box)<ProfileIconBoxProps>`
    right: 25px;
    top: 15px;
    border-radius: 19px;
    width: 39px;
    height: 39px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background-color: ${theme.color.tuna};
    cursor: pointer;
    color: ${({ isOpen }) =>
        isOpen ? theme.color.lightningYellow : theme.color.white};
    z-index: 1000;
    box-sizing: border-box;
`;

export const WaitingTasksBox = styled(Box)`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const StyledDropDownBox = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
`;

export const StyledBox = styled(Box)`
    border-radius: 2px;
    background-color: ${theme.color.darkBlue};
    color: ${theme.color.raisinBlack};
    min-width: 160px;
    right: 25px;
    top: 30px;
    z-index: 999;
`;

export const ToolbarContainer = styled(Box)`
    display: flex;
`;

export const DiscussionsContainer = styled(Box)({
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(245, 179, 9, 0.1)',
    borderRadius: '50%',
    width: '46px',
    height: '46px',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: 'rgba(245, 179, 9, 0.2)'
    }
});

export const NavbarIconContainer = styled(Box)({
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '46px',
    height: '46px',
    cursor: 'pointer',
    '&:hover': {
        opacity: 0.8
    }
});

export const DiscussionsIcon = styled(DiscussionIcon)({
    width: '20px',
    height: '20px',
    color: theme.color.white
});

export const DiscussionsNotification = styled(DiscussionNotificationIcon)({
    position: 'absolute',
    top: '8px',
    right: '9px',
    width: '10px',
    height: '10px',
    color: theme.color.errorRed
});

export const FeedbackIcon = styled(FeedbackSvg)({
    width: '20px',
    height: '20px',
    color: theme.color.white
});

export const BugIcon = styled(BugSvg)({
    width: '20px',
    height: '20px',
    color: theme.color.white
});
